import { MenuTypes } from '@zeptonow/zui/Menu';
import { FilterRoutesInterface } from './types';

export const findNode = (
  key: keyof MenuTypes,
  currentRoute: string,
  routes: MenuTypes[]
): MenuTypes | undefined => {
  for (const node of routes) {
    if (node[key]) {
      const pattern = new RegExp(
        '^' + (node[key] as string)?.split(':')[0] + '([^/]+)$'
      );
      if (
        currentRoute.indexOf((node[key] as string)?.split(':')[0]) !== -1 &&
        pattern.test(node[key] as string)
      )
        return node;
      if (node[key] === currentRoute) return node;
      if (node.children) {
        const child = findNode(key, currentRoute, node.children);
        if (child) return child;
      }
    }
  }
};

export const filterRoutes: FilterRoutesInterface = ({ routes }) => {
  if (!routes || !routes.length) return undefined;
  return routes
    .filter((route) => !route.breadcrumbsExclusion)
    .map((route) => ({
      ...route,
      children: filterRoutes({
        routes: route.children,
      }),
    }));
};
